// extracted by mini-css-extract-plugin
export var close = "CloseButton-module--close--e0623";
export var closeIcon = "CloseButton-module--closeIcon--c0e75";
export var fadeInAnimation = "CloseButton-module--fadeInAnimation--ac2b6";
export var sizeSm = "CloseButton-module--sizeSm--3583c";
export var themeDark = "CloseButton-module--themeDark--1abf0";